// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freelance-list-filters{border:1px solid #e0edff;border-radius:6px;padding:0.5rem;background-color:white;gap:2.5rem;margin-top:0.2rem}.freelance-list-filters .filter-group-col .tw-card-row{gap:0.2rem}.freelance-list-filters .filter-group-col .form-check-input{position:static;margin-left:0}@media (max-width: 767.98px){.freelance-list-filters{flex-direction:column;max-height:30vh;overflow:auto;gap:0}.freelance-list-filters .filter-group-col .tw-card-row{gap:0}}\n", ""]);
// Exports
module.exports = exports;
